import { render, staticRenderFns } from "./AzDistributorsReadOnly.vue?vue&type=template&id=56844626"
import script from "./AzDistributorsReadOnly.vue?vue&type=script&lang=js"
export * from "./AzDistributorsReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports